import {useEffect, useState} from 'react'
import Mapa from './Mapa'
import Tabla from './Tabla'
import {Box, Button, LinearProgress, } from "@material-ui/core";

const MapaPoligono =()=>{
    const[lista, setLista]= useState([])
    const[bandera, setBandera]= useState(true)
    const [contador, setContador] = useState(1);
    useEffect(()=>{
        if (!bandera) {
            setTimeout(() => {
                const auxLocalStg =  localStorage.getItem('auxPol') ?  JSON.parse(localStorage.getItem('auxPol')):[]
                if (auxLocalStg.length!==0) {
                    setLista(auxLocalStg)
                }
                setBandera(true)
            }, 300);
        }
    },[bandera])

    const limpiar =()=>{
        localStorage.removeItem("auxPol")
        setBandera(false)
        setLista([])
        setContador(1)
    }

    const funcionUltimo =()=>{
        const auxLocalStg =  localStorage.getItem('auxPol') ?  JSON.parse(localStorage.getItem('auxPol')):[]
        if (auxLocalStg.length!==0) {
            if (auxLocalStg.length===1) {
                limpiar()
            }
            else{
                auxLocalStg.pop()
                localStorage.setItem('auxPol',JSON.stringify(auxLocalStg))
                setContador(contador-1)
                setBandera(false)
            }            
        }        
    }

    return(
    <Box display={"flex"} >
        <Box width={"801px"}>
            {bandera ? 
                <Mapa lista={lista} setLista={setLista} setActualiza={()=>setBandera(!bandera)} 
                    contador={contador} setContador={setContador} />
            :<Box mt={5}><LinearProgress/></Box>}
        </Box>
        <Box>
            <Button onClick={limpiar}>Limpiar</Button>
            <Button onClick={funcionUltimo} style={{marginLeft:"1rem", }}>Borrar ultimo</Button>
            <Tabla lista={lista} bandera={bandera} />
        </Box>
    </Box>)
}

export default MapaPoligono